import type { NavigateFunction } from 'react-router';

let _navigate: NavigateFunction | null = null;

/** Called from within the React Router context to register the navigate function */
export function setNavigate(navigate: NavigateFunction) {
  _navigate = navigate;
}

/**
 * Returns the registered navigate function, or null if not yet registered
 *
 * @example
 * ```ts
 * // eg, in axios:
 * const navigate = getNavigate();
 * if (navigate) navigate('/login');
 * else window.location.href = appUrl('/login');
 * ```
 */
export function getNavigate(): NavigateFunction | null {
  return _navigate;
}

export const appUrl = (route: string) =>
  `${import.meta.env.BASE_URL.replace(/\/$/, '')}${route}`;
